import { LOCIZE_NS } from '@avanta/shared/constants/common';
import {
  createConfirmPasswordValidator,
  validationsPassword,
  validationsRequired,
} from '@avanta/shared/constants/validations';

export const initialFormData = {
  password: '',
  confirmPassword: '',
};

export const formValidation = {
  password: validationsPassword,
  confirmPassword: {
    required: `${LOCIZE_NS.COMMON}:Common.required`,
    rules: {
      ...validationsRequired,
    },
    validate: createConfirmPasswordValidator(
      'password',
      'RecoverPassword.PasswordChange.confirmPassword.error'
    ),
  },
};
